import AboutMe from "../../Components/AboutMe";

const AboutMePage = () =>{
    return(
        <>
            <AboutMe/>
        </>
    )
}

export default AboutMePage;